// @flow

import * as React from 'react';

import { mapURLSearchParamsToQuery } from '@gandi/app-runner';

import type { WithRouterProps } from 'src/helpers/withRouter';

import { Layout } from '../../components/Layout';

import { handleMarketingParams } from '../../modules/app/actions';
import type { StaticHandlerArgsWithMarketing } from '../../modules/app/actions';
import setPublicHTTPCache from '../../modules/app/public-http-cache';
import { stopSSE } from '../../modules/app/sse';

import type { FullState, PreFetchArgs } from '../../types';

import { saveSearch } from '../modules/actions';

import { TransferPage } from './TransferPage';

export type Query = {
  search?: string,
};
export type StateProps = {
  hasCorporateTLDs: boolean,
  hasResults: boolean,
};
export type InjectedProps = {
  ...WithRouterProps<>,
};
export type DispatchProps = {
  fetchCorporatePackMonthlyPrices: () => Promise<any>,
  validateSearch: (value: string) => Promise<void>,
  resetAllResults: () => void,
  resetSearch: () => void,
};

export type Props = {
  ...StateProps,
  ...InjectedProps,
  ...DispatchProps,
};

export default class DomainTransferInComponent extends React.Component<Props> {
  static async handleRedirect(args: StaticHandlerArgsWithMarketing<>) {
    await handleMarketingParams(args);
    await Layout.handleRedirect(args);
    // $FlowFixMe[incompatible-call]
    setPublicHTTPCache(args);
  }

  static async preFetch(
    args: PreFetchArgs<{}, void, Query, FullState>,
  ): Promise<any> {
    const search = args.query.search;
    if (search) {
      args.dispatch(saveSearch(search));
    }

    return Layout.preFetch(args);
  }

  componentDidMount() {
    const { search }: Query = mapURLSearchParamsToQuery(
      this.props.searchParams,
    );
    // Client-side links to /domain/transfer
    if (search && !this.props.hasResults) {
      this.props.validateSearch(`${search}`);
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.hasCorporateTLDs && this.props.hasCorporateTLDs) {
      this.props.fetchCorporatePackMonthlyPrices();
    }
  }

  componentWillUnmount() {
    this.props.resetAllResults();
    this.props.resetSearch();
    stopSSE();
  }

  render(): React.Node {
    return <TransferPage />;
  }
}
